enum ERedirectType {
    
    STAY_CURRENT_PAGE = 1,
    REDIRECT_NEW_TAB = 2,
    OPEN_POPUP = 3
    
}

export default ERedirectType;
